<div class="sidebar-container">
	<app-sidebar-header class="mx-8"></app-sidebar-header>

	<div class="sidebar-items-wrapper mx-8">
		<app-sidebar-items></app-sidebar-items>
	</div>

	<!-- <app-sidebar-footer></app-sidebar-footer> -->
</div>
